import { render, staticRenderFns } from "./SurveySvg.vue?vue&type=template&id=167a9bbe&"
import script from "./SurveySvg.vue?vue&type=script&lang=js&"
export * from "./SurveySvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports